import { useMemo } from 'react';
import { useTokensPricesV4 } from '@app/hooks/merkl/useTokensPricesV4';
import { formatUnits } from 'ethers/lib/utils';
import { useMetromUserRewards } from '@app/hooks/metrom/useMetromUserRewards';

export function useMetromMarketMakerTokensDetails() {
  const { data, isLoading } = useMetromUserRewards();

  const rewardTokens = useMemo(() => {
    if (!data) {
      return [];
    }

    return data.map(d => d.token.symbol);
  }, [data]);

  const prices = useTokensPricesV4(rewardTokens);

  const totalValue = useMemo(() => {
    if (!data) {
      return;
    }

    return data.reduce((res, item) => {
      const { amount } = item;
      const { symbol, decimals } = item.token;

      const displayValue = formatUnits(amount, decimals);
      const usdValue =
        prices[symbol] && displayValue ? prices[symbol] * +displayValue : 0;

      res += usdValue;

      return res;
    }, 0);
  }, [data, prices]);

  return {
    isLoading: isLoading,
    totalUSD: totalValue,
    tokensSymbols: rewardTokens,
    userRewards: data,
    rewardsChainIds: data?.map(d => d.chainId)
  };
}
